<template>
  <b-navbar class="menu" type="is-primary">
    <template slot="brand">
      <b-navbar-item tag="router-link" :to="{ path: '/' }">
        <img src="@/assets/logo.png" alt="Dengo e Arte" class="logo" />
      </b-navbar-item>
    </template>
    <template slot="end">
      <b-navbar-item href="#">
        <router-link to="/">
          Início
        </router-link>
      </b-navbar-item>
      <b-navbar-item @click="goToView('about')">
        Sobre
      </b-navbar-item>
      <b-navbar-item @click="goToView('products')">
        Catálogo
      </b-navbar-item>
      <b-navbar-item @click="goToView('contact')">
        Contato
      </b-navbar-item>
    </template>
  </b-navbar>
</template>

<script>
export default {
  methods: {
    goToView(elem) {
      const el = document.getElementById(elem);
      this.$router.push('/');
      el.scrollIntoView({ behavior: 'smooth' });
    },
  },
};
</script>

<style scoped>
.navbar {
  background-color: #5ec6ee;
  padding: 20px 180px 0;
}

a,
a.navbar-item {
  color: white;
  text-transform: uppercase;
  font-size: 14px;
  font-weight: bold;
}

a:hover {
  color: rgba(255, 255, 255, 0.719);
  background-color: transparent;
}

.navbar-item img {
  width: 160px;
  max-height: 100%;
}

.navbar.is-primary .navbar-brand > a.navbar-item:hover {
  background-color: transparent;
}

.navbar.is-primary .navbar-end > a.navbar-item:hover {
  background-color: transparent;
}

@media screen and (max-width: 560px) {
  .navbar {
    padding: 20px 0 10px;
  }
}

@media screen and (max-width: 768px) {
  .navbar {
    padding: 20px 20px 10px;
  }

  .navbar-item img {
    width: 150px;
  }
  .navbar-menu a {
    color: grey;
  }
}

@media screen and (min-width: 768px) {
  .navbar {
    padding: 20px 60px 0;
  }
}
</style>
